import React from 'react'

// styles
import styles from './index.module.scss'
import ArtworkTab from './ArtworkTab'
import ActivityTab from './ActivityTab'

const CollectionTab = props => {
  const { activeTab, artworkType, setArtworkType, filterKey, setFilterKey } = props

  return (
    <div className={styles.container}>
      <div className="w-full flex flex-wrap justify-between gap-[30px] lg:gap-[15px]">
        {activeTab === 0 && <ArtworkTab artworkType={artworkType} setArtworkType={setArtworkType} />}

        {activeTab === 1 && <ActivityTab filterKey={filterKey} setFilterKey={setFilterKey} />}
      </div>
    </div>
  )
}

export default CollectionTab
